export class LookUpValue {
    lookupValueId: number;
    lookupId: number;
    name: string;
    isAssignedAllergy: boolean;
    isAssignedReactions: boolean;
    isAssignedHospitalization: boolean;
    isAssignedPcare: boolean;
    isAssignedInitial: boolean;
    isAssignedSite: boolean;
    isAssignedVaccine: boolean;
    totalItems: number;
    createdByRole: string;
}



export class Lookup {
    lookupId: number;
    name: string;
    description: string;
    modifyAccess: boolean;

}
export class LookupValues {
    lookupValueId: number;
    name: string;
    lookupId: number;
    description: string;
    createdDate: Date;
    createdBy: number;
    modifiedDate: Date;
    modifiedBy: number;
    active?: boolean;
    priority: number
}